export const formatWithMore = (items: string[], max = 3): string => {
  if (!items || items.length === 0) return "";

  if (items.length <= max) {
    return items.join(", ");
  }

  const shown = items.slice(0, max).join(", ");
  const remainingCount = items.length - max;

  return `${shown} & ${remainingCount} more`;
};
